import { $closest, $delegate, $el, $find, $findAll, $qs, $remove } from 'fxdom/es';
import { each, go, html } from 'fxjs/es';
import { BpOptionF } from '../../../BpOption/F/Function/module/BpOptionF.js';
import { BpOptionS } from '../../../BpOption/S/Function/module/BpOptionS.js';
import { BpOptionTmplS } from '../../../BpOption/S/Tmpl/module/BpOptionTmplS.js';
import { discontinuedSizeIds, excludingDiscontinued, soldOutSizeIds } from '../../../ProductColor/S/fs.js';
import { setPriceKeyringAndAcryl } from '../../S/product.js';
import { removeCvBlueLineInMaker } from '../cv_blue_line.js';
import {
  getBaseProductColorsInMaker,
  getBaseProductSizesInMaker,
  getCurrentBpcId,
  getCurrentBpsId,
  getProductColorInMaker,
} from '../getSth.js';
import { eventProductBpcA, getBpcTitle, getCurrentBpcName } from '../Product/bpc_fs.js';
import { makeProductBpcPcHtml } from '../Product/bpc_tmpl.js';
import { eventProductBpsA } from '../Product/bps_fs.js';
import { makeBpsSizeItemHtml } from '../Product/bps_tmpl.js';
import { open_chooser } from '../Product/product_fs.js';
import { product_editor_product_tmpl } from '../Product/product_tmpl.js';
import { fcanvasChanging } from '../util.js';
import { clickHandlerForReviewSummaryCount } from './fs.js';
import { BpOptionUploadTypeS } from '../../../BpOption/UploadType/S/Function/module/BpOptionUploadTypeS.js';
import { isStoreProductCustom } from '../../../Creator/Product/S/fs.js';
import { getCustomLevelFromBox } from '../../../Creator/Setting/F/custom.js';
import { rune } from 'rune-ts';
import {
  BlurInputEvent,
  ChangeSizeRangeEvent,
  FocusInputEvent,
  HandleSliderValueChange,
  SizeGauge,
} from '@modules/NewMaker/UI/sizeGauge/SizeGauge.ts';
import { changeVirtualSelect, processAfterSelect } from '@modules/BpOption/F/Function/bpoption.js';
import { ConfigSentryF } from '@modules/Config/Sentry/F/Function/module/ConfigSentryF.js';
import { MShopUtilF } from '@modules/MShop/Util/F/Function/module/MShopUtilF.js';
import { setupLinkToInputEvents } from '@modules/nfc/F/Function/event.js';
import { LinkToInput } from '@modules/NewMaker/UI/LinkToInput/LinkToInput.ts';
import { Icon } from '@modules/NewMaker/UI/Icon/Icon.ts';
import { SectionA } from '@modules/NewMaker/UI/SectionA/SectionA.ts';
import { Carousel, onSelectEvent } from '@modules/NewMaker/UI/Carousel/Carousel.ts';

function makeArgsForBpsSizeItemHtml() {
  return [
    excludingDiscontinued(
      getBaseProductSizesInMaker(),
      discontinuedSizeIds(getProductColorInMaker(), getBaseProductColorsInMaker()),
    ),
    getCurrentBpsId(),
    soldOutSizeIds(getProductColorInMaker(), getBaseProductColorsInMaker()),
  ];
}

const event = (el) => {
  MShopUtilF.hydrationRune(SizeGauge, LinkToInput, Icon, Carousel, SectionA);

  const carousel_el = el.querySelector('.Carousel');
  if (carousel_el) {
    const carousel = rune.getView(carousel_el, Carousel);

    carousel.addEventListener(onSelectEvent, async (e) => {
      const selected_bp_option_id = e.detail.id;

      const bp_option_group_el = $closest('.bp_option_group', e.currentTarget);

      const select_el = $find('select', bp_option_group_el);

      const bp_option_groups_el = $closest('.bp_option_groups', select_el);

      BpOptionF.selectBpOption({
        bp_option_group_el,
        selected_bp_option_id,
      });

      if (bp_option_group_el.dataset.is_virtual === 'false') {
        $.don_loader_start();
        await processAfterSelect(select_el);
        $.don_loader_end();
      } else {
        $.don_loader_start();
        await changeVirtualSelect(bp_option_groups_el);
        setTimeout(() => {
          $.don_loader_end();
        }, 5000);
      }
    });
  }

  const link_to_input_el = el.querySelector('.LinkToInput');
  const nfc_product = G.mp.maker?.nfcProduct;
  if (link_to_input_el && nfc_product) {
    setupLinkToInputEvents(link_to_input_el);
  }

  const size_gauge_el = el.querySelector('.SizeGauge');
  if (size_gauge_el && G.mp.maker.flexiApi) {
    const sizeGauge = rune.getView(size_gauge_el, SizeGauge);
    sizeGauge.addEventListener(ChangeSizeRangeEvent, async (e) => {
      try {
        const canvas_zoom_wrapper = $qs('.canvas_zoom_wrapper');
        const product = getProductColorInMaker();
        const real_size = await G.mp.maker.flexiApi.updateSize(product, canvas_zoom_wrapper, e.detail);
        if (!real_size) return;

        const bp_option_group_el = go(size_gauge_el, $closest('.bp_option_group'), $find('select'));
        await processAfterSelect(bp_option_group_el);

        sizeGauge.updateDOM(real_size);

        if (box.sel('shared_product')) {
          if (G.mp.maker.is_shared_product_design_changed) G.mp.maker.is_shared_product_design_changed();
        }

        if (e.detail.is_valid === false) {
          sizeGauge.showSizeAdjustedToast();
        }
      } catch (e) {
        ConfigSentryF.error(e);
      }
    });
    sizeGauge.addEventListener(FocusInputEvent, () => $.body_fixed(true));
    sizeGauge.addEventListener(BlurInputEvent, () => $.body_fixed(false));
    sizeGauge.addEventListener(HandleSliderValueChange, (e) => {
      const real_size = G.mp.maker.flexiApi.handleRangeSizeValue(e.detail.slider_value);
      sizeGauge.updateDOM(real_size);

      if (box.sel('shared_product')) {
        if (G.mp.maker.is_shared_product_design_changed) G.mp.maker.is_shared_product_design_changed();
      }
    });
  }

  return go(
    el,
    $delegate(
      'click',
      '.product_editor_ev .color_item:not(.selected)',
      fcanvasChanging(async function (e) {
        $.don_loader_start();
        removeCvBlueLineInMaker();
        await eventProductBpcA(e.currentTarget);
        if ($1('#marpplizer .product_editor .size.section')) {
          $1('#marpplizer .product_editor .size.section').outerHTML = makeBpsSizeItemHtml(
            ...makeArgsForBpsSizeItemHtml(),
          );
        }
        $.don_loader_end();
      }),
    ),
    $delegate('click', '.open_chooser', open_chooser),
    $delegate('click', '.review_summary .counts', clickHandlerForReviewSummaryCount),
    $delegate(
      'click',
      '.product_editor_ev .size.section li:not(.selected)',
      fcanvasChanging(eventProductBpsA),
    ),
  );
};

export const marpplizer_home = function () {
  const product_color = box().maker.product_color;
  const is_custom_editor = isStoreProductCustom(getCustomLevelFromBox());

  const has_bp_option_groups = BpOptionS.getBaseProductsListBpOptionGroups(
    product_color._.base_product,
  )?.length;
  const is_bpc_show = !product_color._.base_product.is_bpc_hidden;
  const is_bps_show = !has_bp_option_groups && !product_color._.base_product.is_bps_hidden;
  product_color._.base_product._.base_products_bp_option_groups =
    product_color._.base_product._.base_products_bp_option_groups.sort(function (a, b) {
      const a_bog = a._.bp_option_group;
      const b_bog = b._.bp_option_group;
      if (b_bog.is_visibility === a_bog.is_visibility) {
        return a_bog.no - b_bog.no;
      }
      return b_bog.is_visibility - a_bog.is_visibility;
    });
  const base_products_bp_option_groups = product_color._.base_product._.base_products_bp_option_groups;
  const id = 'marpplizer_home';
  setPriceKeyringAndAcryl(product_color);

  const html_body = html`
    <div class="main_head">Product</div>
    ${product_editor_product_tmpl(getProductColorInMaker())}
    ${is_bpc_show
      ? makeProductBpcPcHtml(
          getBaseProductColorsInMaker(),
          getCurrentBpcName(),
          getBpcTitle(),
          getCurrentBpcId(),
        )
      : ``}
    ${is_bps_show ? makeBpsSizeItemHtml(...makeArgsForBpsSizeItemHtml()) : ``}
    ${has_bp_option_groups
      ? html`
          <div class="section maker-product-info__bp-option-groups">
            ${BpOptionTmplS.bpAllOptions({
              product: product_color,
              is_custom_editor,
            })}
          </div>
        `
      : ``}
    ${BpOptionUploadTypeS.UPLOAD_TYPE.isUploadType(base_products_bp_option_groups)
      ? html`
          <div class="section maker-product-info__upload-type">
            ${BpOptionUploadTypeS.UPLOAD_TYPE.html.uploadHtml(product_color)}
          </div>
        `
      : ``}
    <!-- 도수 색상 카드 -->
    ${BpOptionF.bizDosuCard.get.html()}
  `;
  /* (도서 산간 지역의 경우, 추가 비용 3,000원이 발생합니다.)*/
  // 만들기 툴은 곧 제공 예정이에요!
  const x_image = html`<img src="//s3.marpple.co/files/u_193535/2024/3/original/846518fd0bf13a97986b396befa3002aac127f771.png" style="width:8px;height:8px;margin-left:8px;" alt=""></img>`;
  return {
    name: 'home',
    app: 'base1',
    tooltips: [
      {
        content: go(
          html`
            <div style="text-align: center;">
              <span>${TT('biz::opt::title::tippy_content')}</span>${x_image}
            </div>
          `,
          $el,
        ),
        target_unique_class: '.group_discount_guide',
      },
      {
        content: go(
          html`
            <div style="text-align: center;">
              <span>${TT('maker_upload_type::만들기 툴은 곧 제공 예정이에요!')}</span>${x_image}
            </div>
          `,
          $el,
        ),
        target_unique_class: '.maker-upload-type-selector__is-not-ready-editor',
      },
    ],
    html: html`
      <div class="activity" id="${id}">
        <div class="body product_editor product_editor_ev marpplizer_contents_wrapper">${html_body}</div>
      </div>
    `,
    remove: (el) => {
      go(el, $findAll(`#${id}`), each($remove));
    },
    event,
  };
};
